import { Injectable } from '@angular/core';
import { FeatureTogglingService } from '@app/services/shared/feature-toggling.service';
import { TranslateService } from '@ngx-translate/core';
import { RouteMenuItem } from './../models/components/route-menu-item';

@Injectable()
export class Menu {
    projectConfig = this.featureTogglingService.featureTogglingConfig
    constructor(private translateService: TranslateService, 
        private featureTogglingService: FeatureTogglingService,
    ) {
    }

    getMenuRoutes(): RouteMenuItem[] {
        return [
            {
                path: '/dashboard',
                title: this.translateService.instant('Dashboard'),
                icon: 'dashboard',
                children: [],
                class: 'active',
                permissions: ["admin"],
            },
            {
                path: '',
                title: this.translateService.instant('Orders'),
                permissions: ["CreateBusinessOrders", "Orders_ViewOrders", "Orders_DispatchOrdersPage", "OrderTracking", "MailItemTracking"],
                icon: 'library_books',
                active: this.projectConfig.orders.active,
                children: [
                    {
                        path: '/create-business-order',
                        title: this.translateService.instant('Create Business Order'),
                        icon: 'fact_check',
                        children: [],
                        permissions: ["CreateBusinessOrders"],
                        active: this.projectConfig.orders.pages['create-business-order'].active,
                    },
                    {
                        path: '/manage-order/local',
                        title: this.translateService.instant('Local Post Orders'),
                        icon: 'analytics',
                        children: [],
                        permissions: ["Orders_ViewOrders"],
                        active: !this.projectConfig.orders.pages['local-post-order'].concierge,
                    },
                    // {
                    //     path: '/manage-order/delivery',
                    //     title: this.translateService.instant('Delivery Post Orders'),
                    //     icon: 'analytics',
                    //     children: [],
                    //     permissions: ["Orders_ViewOrders"],
                    // },
                    // {
                    //     path: '/manage-order/international',
                    //     title: this.translateService.instant('International Post Orders'),
                    //     icon: 'analytics',
                    //     children: [],
                    //     permissions: ["Orders_ViewOrders"],
                    // },
                    {
                        path: '/order-tracking',
                        title: this.translateService.instant('Order Tracking'),
                        icon: 'search',
                        permissions: ["OrderTracking"],
                        children: []
                    },
                    {
                        path: '/item-tracking',
                        title: this.translateService.instant('Mail Item Tracking'),
                        icon: 'search',
                        permissions: ["MailItemTracking"],
                        children: []
                    },
                    {
                        path: '/manage-internal-post',
                        title: this.translateService.instant('Manage Internal Post'),
                        icon: 'analytics',
                        permissions: [],
                        children: [],
                        active: false
                    },
                ]
            },
            {
                path: '',
                title: this.translateService.instant('Operations'),
                permissions: ["WorkOrders_ViewOrders", "ReturnedMailitem_ViewReturnedMailitem", "Orders_DispatchOrdersPage"],
                icon: 'library_books',
                active: this.projectConfig.operations.active,

                children: [
                    {
                        path: '/dispatch-orders',
                        title: this.translateService.instant('Dispatch Orders'),
                        icon: 'fact_check',
                        children: [],
                        permissions: ["Orders_DispatchOrdersPage"],
                    },
                    {
                        path: '/manage-workorders',
                        title: this.translateService.instant('Manage Workorders'),
                        icon: 'bubble_chart',
                        children: [],
                        permissions: ["WorkOrders_ViewOrders"],
                    },
                    {
                        path: '/returned-items',
                        title: this.translateService.instant('Returned Items'),
                        icon: 'fact_check',
                        permissions: ['ReturnedMailitem_ViewReturnedMailitem'],
                        children: []
                    },
                    {
                        path: '/post-room',
                        title: this.translateService.instant('Post Room'),
                        icon: 'fact_check',
                        permissions: [],
                        children: [],
                        active: false,

                    },
                ]
            },
            {
                path: '',
                title: this.translateService.instant('Finance'),
                permissions: ["ReadContract", "ReadPriceQoutation", "ReadPriceList", "ListInvoices"],
                icon: 'paid',
                active: this.projectConfig.finance.active,

                children: [
                    {
                        path: '/contracts',
                        title: this.translateService.instant('Contracts'),
                        icon: 'bookmark_added',
                        children: [],
                        permissions: ["ReadContract"],
                    },

                    {
                        path: '/manage-pq',
                        title: this.translateService.instant('Manage PQ'),
                        icon: 'library_books',
                        children: [],
                        permissions: ["ReadPriceQoutation"],
                    },
                    {
                        path: '/manage-pl',
                        title: this.translateService.instant('Manage Price List'),
                        icon: 'library_books',
                        children: [],
                        permissions: ["ReadPriceList"],
                    },
                    {
                        path: '/manage-invoice',
                        title: this.translateService.instant('Invoices'),
                        children: [],
                        permissions: [ "GenerateInvoice", "ListInvoices", "ViewInvoice", "EditInvoices", "PrintInvoice", "DeleteInvoices"],
                        icon: 'notifications'
                    }
                ]
            },
            {
                path: '',
                title: this.translateService.instant('Reports'),
                permissions: ["LocalMessageDistributionReport",
                    "BusinessCustomerAndBranchesReport",
                    "BusinessCustomerDistributionReport",
                    "DeliveredMailitemsReport",
                    "ReturnedMailitemReport",
                    "AgentCourierReport",
                    "PaymentMethodReport"
                ],
                icon: 'library_books',
                children: [
                    {
                        path: '/reports/local-message-distribution-report',
                        title: this.translateService.instant('Distribution Report'),
                        permissions: ["LocalMessageDistributionReport"],
                        icon: 'library_books'
                    },
                    {
                        path: '/reports/business-customer-and-branches-report',
                        title: this.translateService.instant('Business Customer AndBranches Report'),
                        permissions: ["BusinessCustomerAndBranchesReport"],
                        icon: 'library_books'
                    },
                    {
                        path: '/reports/business-customer-distribution-report',
                        title: this.translateService.instant('business Customer Distribution Report'),
                        permissions: ["BusinessCustomerDistributionReport"],
                        icon: 'library_books'
                    },

                    {
                        path: '/reports/delivered-mailitems-report',
                        title: this.translateService.instant('Delivered MailItem Statement'),
                        permissions: ["DeliveredMailitemsReport"],
                        icon: 'library_books'
                    },
                    {
                        path: '/reports/returned-mailitem-report',
                        title: this.translateService.instant('Returned MailItem Statement'),
                        permissions: ["ReturnedMailitemReport"],
                        icon: 'library_books'
                    },
                    {
                        path: '/reports/total-for-branches-report',
                        title: this.translateService.instant('Total For Branches Report'),
                        permissions: [],
                        icon: 'library_books'
                    },
                    {
                        path: '/reports/distributed-mailitem-to-each-branch-report',
                        title: this.translateService.instant('Distributed Mailitem To Each Branch Report'),
                        permissions: [],
                        icon: 'library_books'
                    },
                    {
                        path: '/reports/distribution-of-local-mailitems-department-delegates-report',
                        title: this.translateService.instant('Distribution Of Local Mailitems Department Delegates Report'),
                        permissions: [],
                        icon: 'library_books',
                        active: !this.projectConfig.orders.pages['local-post-order'].concierge,
                    },

                    {
                        path: '/reports/payment-method-report',
                        title: this.translateService.instant('Payment Method Report'),
                        permissions: ["PaymentMethodReport"],
                        icon: 'library_books'
                    },
                    {
                        path: '/reports/agent-courier-report',
                        title: this.translateService.instant('Agent Courier Report'),
                        permissions: ["AgentCourierReport"],
                        icon: 'library_books'
                    },
                ]
            },
            {
                path: '',
                title: this.translateService.instant('Resources'),
                permissions: ['ReadBusinessCustomer', 'UpdateCompanyProfile', 'ReadAllManagers', 'ReadAgent', 'CreateDriver', 'UpdateDriver', 'DeleteDriver', 'ListDrivers', 'ExportDriversToExcel', 'ListCouriers'],
                icon: 'library_books',
                active: this.projectConfig.resources.active,
                children: [
                    {
                        path: '/company',
                        title: this.translateService.instant('Company Profile'),
                        icon: 'person',
                        children: [],
                        permissions: ["UpdateCompanyProfile"],
                        active: this.projectConfig.resources.pages['company'].active
                    },
                    {
                        path: '/access-control',
                        title: this.translateService.instant('Access Control'),
                        icon: 'verified',
                        permissions: ['ReadAllRoles'],
                        children: [],
                        active: this.projectConfig.resources.pages['access-control'].active

                    },
                    {
                        path: '/manage-staff',
                        title: this.translateService.instant('Manage Staff'),
                        icon: 'person',
                        children: [],
                        permissions: ['ReadAllManagers'],
                        active: this.projectConfig.resources.pages['manage-staff'].active

                    },
                    {
                        path: '/manage-drivers',
                        title: this.translateService.instant('Manage Drivers'),
                        icon: 'person',
                        children: [],
                        permissions: ['ReadAgent', 'CreateDriver', 'UpdateDriver', 'DeleteDriver', 'ListDrivers', 'ExportDriversToExcel'],
                        active: this.projectConfig.resources.pages['manage-drivers'].active

                    },
                    {
                        path: '/business-accounts',
                        title: this.translateService.instant('Business Customers'),
                        icon: 'person',
                        permissions: ["ReadBusinessCustomer"],
                        children: [],
                        active: this.projectConfig.resources.pages['business-accounts'].active

                    },
                    {
                        path: '/manage-couriers',
                        title: this.translateService.instant('Agent/Couriers'),
                        permissions: ["CreateCourier", "DeleteCourier", "UpdateCourier", "ListCouriers"],
                        icon: 'library_books',
                        active: this.projectConfig.resources.pages['manage-couriers'].active,

                    },
                ]
            },
            {
                path: '',
                title: this.translateService.instant('Settings'),
                permissions: ["ListCountries", "ListAreas", "ListGovernorates", "ListLengthUOMs", 'ReadGeofence', 'ReadAllRoles', "ListLanguages", "ListLanguages", "ListWeightUOMs", "ListItemTypes", "ListTermsAndConditions"],
                icon: 'library_books',
                active: this.projectConfig.settings.active,
                children: [
                    {
                        path: '/geo-fences',
                        title: this.translateService.instant('Geo Fences'),
                        icon: 'person',
                        permissions: ['ReadGeofence'],
                        children: [],
                        active: this.projectConfig.settings.pages['geo-fences'].active,

                    },


                    {
                        path: '/settings/item-return-reason',
                        title: this.translateService.instant('Item Return Reason'),
                        permissions: ["CreateItemReturnReason", "UpdateItemReturnReason", "DeleteItemReturnReason", "ListItemReturnReasons"],
                        icon: 'swap_horizontal_circle',
                        active: this.projectConfig.settings.pages['item-return-reason'].active,

                    },
                    {
                        path: '/settings/mail-item-type',
                        title: this.translateService.instant('Mail Item Type'),
                        permissions: ["CreateItemType", "UpdateItemType", "DeleteItemType", "ListItemTypes"],
                        icon: 'markunread_mailbox',
                        active: this.projectConfig.settings.pages['mail-item-type'].active,

                    },
                    {
                        path: '/settings/weight-uom',
                        title: this.translateService.instant('Weight-UOM'),
                        permissions: ["CreateWeightUOM", "UpdateWeightUOM", "DeleteWeightUOM", "ListWeightUOMs"],
                        icon: 'line_weight',
                        active: this.projectConfig.settings.pages['weight-uom'].active,

                    },
                    {
                        path: '/settings/length-uom',
                        title: this.translateService.instant('LengthUOM'),
                        permissions: ["CreateLengthUOM", "UpdateLengthUOM", "DeleteLengthUOM", "ListLengthUOMs"],
                        icon: 'swap_horizontal_circle',
                        active: this.projectConfig.settings.pages['length-uom'].active,


                    },

                    {
                        path: '/settings/manage-department',
                        title: this.translateService.instant('Manage Department'),
                        permissions: ["ListDepartment"],
                        icon: 'library_books',
                        active: this.projectConfig.settings.pages['manage-department'].active,

                    },

                    {
                        path: '/settings/manage-driver-role',
                        title: this.translateService.instant('Manage Driver Role'),
                        permissions: ["ListDriverRoles"],
                        icon: 'library_books',
                        active: this.projectConfig.settings.pages['manage-driver-role'].active,

                    },
                    {
                        path: '/settings/governorate',
                        title: this.translateService.instant('Governorate'),
                        permissions: ["CreateGovernorate", "UpdateGovernorate", "DeleteGovernorate", "ListGovernorates"],
                        icon: 'language',
                        active: this.projectConfig.settings.pages['governorate'].active,

                    },
                    {
                        path: '/settings/terms-and-conditions',
                        title: this.translateService.instant('Terms And Conditions'),
                        permissions: ["ListTermsAndConditions"],
                        icon: 'library_books',
                        active: this.projectConfig.settings.pages['terms-and-conditions'].active,
                    },
                    {
                        path: '/settings/remark',
                        title: this.translateService.instant('Remark'),
                        permissions: ["ReadRemark"],
                        icon: 'library_books',
                        active: this.projectConfig.settings.pages['remark'].active,
                    },
                    {
                        path: '/settings/manage-service',
                        title: this.translateService.instant('Manage Service'),
                        permissions: ["ListService"],
                        icon: 'library_books',
                        active: this.projectConfig.settings.pages['manage-service'].active,

                    },
                    {
                        path: '/settings/manage-packing-packages',
                        title: this.translateService.instant('Manage Packing Packages'),
                        permissions: ["ListPackingPackage"],
                        icon: 'library_books',
                        active: this.projectConfig.settings.pages['manage-packing-packages'].active,

                    },
                    {
                        path: '/settings/country',
                        title: this.translateService.instant('Country'),
                        permissions: ["CreateCountry", "UpdateCountry", "DeleteCountry", "ListCountries"],
                        icon: 'language',
                        active: this.projectConfig.settings.pages['country'].active,
                    }
                    ,
                    {
                        path: '/settings/area',
                        title: this.translateService.instant('Area'),
                        permissions: ["CreateArea", "DeleteArea", "UpdateArea", "ListAreas"],
                        icon: 'library_books',
                        active: this.projectConfig.settings.pages['area'].active,

                    },
                    {
                        path: '/settings/business-type',
                        title: this.translateService.instant('Business Type'),
                        permissions: [],
                        icon: 'library_books',
                        active: this.projectConfig.settings.pages['business-type'].active,

                    },
                   



                ]
            },


        ];
    }
}

